import { render } from "./ClaimMediaGallery.vue?vue&type=template&id=50dd40ca&bindings={}"
import script from "./ClaimMediaGallery.vue?vue&type=script&lang=ts"
export * from "./ClaimMediaGallery.vue?vue&type=script&lang=ts"

import "./ClaimMediaGallery.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script